module.exports = __webpack_public_path__ + "images/926598a2d3017887e7c3a3a1e7af0279-scottsdale_small_logo.png";